import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import Split from '../../../Shared/Split';
import PartnerOfferingField from './PartnerOfferingField';
import PartnerOfferingForm from './PartnerOfferingForm';

const PartnerOffering = ({ refresh, offering = {}, locked = true }) => {
    const [editing, setEditing] = useState(false);
    const toggleEditing = () => setEditing(!editing);

    const { availableOfferings } = useSelector((state) => ({
        availableOfferings: state.offerings.availableOfferings,
    }));

    const comparedOfferings = useMemo(() => {
        return compareOfferings(availableOfferings, offering);
    }, [availableOfferings, offering]);

    useEffect(() => setEditing(false), [offering, locked]);

    return (
        <Container className="border mb-2 p-2 bg-light text-dark border-secondary">
            {!editing ? (
                <>
                    <Row>
                        <Col>
                            <Split>
                                <h4
                                    className="hide-overflow"
                                    title={offering?.name}>
                                    {offering?.name}
                                </h4>
                                {!locked && (
                                    <FontAwesomeIcon
                                        className="pop-hover"
                                        icon={faEdit}
                                        onClick={toggleEditing}
                                        size="lg"
                                    />
                                )}
                            </Split>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {comparedOfferings.map((x) => (
                                <PartnerOfferingField
                                    key={x.id}
                                    title={x.name}
                                    value={x.isEnabled}
                                    subOfferings={x.subOfferings}
                                />
                            ))}
                        </Col>
                    </Row>
                </>
            ) : (
                <Row>
                    <Col>
                        <PartnerOfferingForm
                            offering={offering}
                            partnerId={offering?.partnerId}
                            refresh={refresh}
                            toggle={toggleEditing}
                            offeringsList={comparedOfferings}
                        />
                    </Col>
                </Row>
            )}
        </Container>
    );
};

const compareOfferings = (availableOfferings = [], partnerOffering = []) => {
    return availableOfferings.map((x) => {
        return {
            id: x?.id,
            name: x?.name,
            isEnabled: partnerOffering.bitwerxOfferingIds.includes(x?.id),
            subOfferings: x?.subOfferings?.map((s) => {
                return {
                    id: s?.id,
                    name: s?.displayName ?? s?.name,
                    isEnabled: partnerOffering?.bitwerxSubOfferingIds.includes(
                        s?.id
                    ),
                };
            }),
        };
    });
};

export default PartnerOffering;
